var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _g2, _path13, _path14, _g3, _path15, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.1379 8.31622H21.8617C21.766 8.31622 21.6775 8.36726 21.6297 8.45014L3.49193 39.866C3.44409 39.9489 3.44409 40.0511 3.49193 40.134L21.6299 71.5498C21.6777 71.6327 21.7662 71.6837 21.8619 71.6837H58.1377C58.2334 71.6837 58.3219 71.6327 58.3697 71.5498L76.5078 40.134C76.5556 40.0511 76.5556 39.9489 76.5078 39.866L58.37 8.45014C58.3222 8.36726 58.2337 8.31622 58.1379 8.31622Z",
    fill: "url(#paint0_linear_1577_4307)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4997 9.43054H22.4996C22.4072 9.43054 22.3218 9.47982 22.2757 9.55982L4.77589 39.8707C4.72965 39.9507 4.72965 40.0493 4.77589 40.1293L22.2757 70.4401C22.322 70.5201 22.4072 70.5694 22.4996 70.5694H57.4997C57.592 70.5694 57.6775 70.5201 57.7236 70.4401L75.2236 40.1293C75.2698 40.0493 75.2698 39.9507 75.2236 39.8707L57.7236 9.55982C57.6775 9.47982 57.592 9.43054 57.4997 9.43054Z",
    fill: "url(#paint1_linear_1577_4307)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M56.8444 68.4531H25.7609C24.4567 68.4531 23.2518 67.7573 22.5998 66.6278L7.058 39.7086C6.40584 38.5793 6.40584 37.188 7.058 36.0585L21.6202 10.8358C21.5105 10.9744 21.3873 11.1001 21.2974 11.2558L5.7556 38.1749C5.1036 39.3041 5.1036 40.6955 5.7556 41.8249L21.2975 68.7441C21.9495 69.8734 23.1545 70.5693 24.4586 70.5693H55.5422C56.8463 70.5693 58.0513 69.8734 58.7034 68.7441L59.683 67.0477C58.9966 67.9144 57.9689 68.4531 56.8444 68.4531Z",
    fill: "#C20000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M74.2445 38.1749L58.7027 11.2557C58.0506 10.1261 56.8456 9.43042 55.5414 9.43042H24.4579C23.1538 9.43042 21.9488 10.1263 21.2968 11.2557L20.9902 11.7863C21.6107 11.3234 22.3555 11.0367 23.1555 11.0367H54.239C55.5432 11.0367 56.7481 11.7325 57.4003 12.8619L72.9419 39.781C73.5941 40.9103 73.5941 42.3018 72.9419 43.4311L57.7064 69.8199C58.0979 69.528 58.4502 69.1808 58.7026 68.744L74.2442 41.8248C74.8966 40.6955 74.8966 39.3042 74.2445 38.1749Z",
    fill: "#FFEEA2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1011 15.3687H25.8998C25.8254 15.3687 25.7566 15.4083 25.7195 15.4728L11.6187 39.8959C11.5815 39.9603 11.5815 40.0397 11.6187 40.1042L25.7195 64.5272C25.7567 64.5917 25.8254 64.6314 25.8998 64.6314H54.1011C54.1755 64.6314 54.2443 64.5917 54.2815 64.5272L68.382 40.1042C68.4191 40.0397 68.4191 39.9603 68.382 39.8959L54.2815 15.4728C54.2443 15.4085 54.1755 15.3687 54.1011 15.3687Z",
    fill: "url(#paint2_linear_1577_4307)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M67.5922 38.5294L55.0693 16.8393C54.5441 15.9293 53.5732 15.3688 52.5225 15.3688H27.4767C26.426 15.3688 25.4551 15.9293 24.9297 16.8393L24.8242 17.0221C25.3569 16.1473 26.3021 15.6057 27.3297 15.6057H52.3753C53.4261 15.6057 54.3972 16.1662 54.9226 17.0761L67.4453 38.7664C67.9708 39.6763 67.9708 40.7974 67.4453 41.7077L55.0284 63.2139C55.0401 63.1945 55.058 63.1805 55.0693 63.1606L67.5922 41.4705C68.1177 40.5606 68.1177 39.4395 67.5922 38.5294Z",
    fill: "url(#paint3_linear_1577_4307)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.723 16.0286H26.2769C26.2044 16.0286 26.1376 16.0672 26.1014 16.1301L12.3787 39.8987C12.3425 39.9614 12.3425 40.0387 12.3787 40.1014L26.1016 63.8701C26.1377 63.9328 26.2048 63.9715 26.2771 63.9715H53.723C53.7955 63.9715 53.8624 63.9328 53.8987 63.8701L67.6212 40.1014C67.6574 40.0387 67.6574 39.9614 67.6212 39.8987L53.8987 16.1301C53.8624 16.0672 53.7955 16.0286 53.723 16.0286Z",
    fill: "url(#paint4_linear_1577_4307)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M53.3869 61.9895H29.0122C27.9898 61.9895 27.0448 61.4442 26.5333 60.5584L14.3459 39.4493C13.8347 38.5637 13.8347 37.4725 14.3459 36.5869L25.5563 17.1701C25.4823 17.2671 25.3955 17.3523 25.3336 17.4597L13.1461 38.569C12.6349 39.4543 12.6349 40.5456 13.1461 41.4312L25.3336 62.5405C25.8451 63.4261 26.7898 63.9715 27.8125 63.9715H52.1871C53.2098 63.9715 54.1547 63.4259 54.6661 62.5405L55.6427 60.8487C55.1058 61.5514 54.2853 61.9895 53.3869 61.9895Z",
    fill: "#FFDD45"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M66.8536 38.5686L54.666 17.4597C54.1548 16.5741 53.2099 16.0283 52.1872 16.0283H27.8126C26.7902 16.0283 25.8449 16.5741 25.3337 17.4597L24.0918 19.6109C24.5225 19.3595 25.0176 19.2192 25.5336 19.2192H49.9083C50.931 19.2192 51.876 19.765 52.3872 20.6506L64.5747 41.7595C65.0859 42.6453 65.0859 43.7363 64.5747 44.6219L53.6292 63.5802C54.0524 63.3333 54.4131 62.9792 54.6664 62.5403L66.8539 41.431C67.3648 40.5456 67.3648 39.4544 66.8536 38.5686Z",
    fill: "url(#paint5_linear_1577_4307)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M40.7476 25.3613L46.4675 32.3424C46.6697 32.5888 46.9316 32.7794 47.2286 32.8954L55.6356 36.1779C56.7278 36.6045 57.1566 37.9237 56.5236 38.9108L51.6518 46.5079C51.4796 46.7762 51.3796 47.0844 51.3611 47.4026L50.8369 56.4125C50.7687 57.5831 49.6463 58.3984 48.5121 58.1013L39.7814 55.8155C39.4727 55.7349 39.1489 55.7349 38.8404 55.8155L30.1095 58.1013C28.9753 58.3984 27.8531 57.5831 27.7851 56.4125L27.2609 47.4026C27.2423 47.0844 27.1423 46.7762 26.9702 46.5079L22.0983 38.9108C21.4654 37.9237 21.8939 36.6045 22.9862 36.1779L31.3932 32.8954C31.6903 32.7792 31.9523 32.5888 32.1543 32.3424L37.8745 25.3613C38.6174 24.4543 40.0046 24.4543 40.7476 25.3613Z",
    fill: "#BA0000"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M41.2162 24.5583L46.9361 31.5394C47.138 31.7861 47.4001 31.9765 47.6972 32.0924L56.1041 35.3749C57.1964 35.8015 57.6249 37.1207 56.9921 38.1077L52.1201 45.705C51.9481 45.9733 51.8479 46.2815 51.8293 46.5996L51.3052 55.6095C51.2372 56.78 50.1149 57.5954 48.9807 57.2986L40.2498 55.0127C39.9415 54.932 39.6175 54.932 39.3092 55.0127L30.5783 57.2986C29.4441 57.5954 28.3218 56.7802 28.2538 55.6095L27.7295 46.5996C27.7109 46.2815 27.6109 45.9733 27.4389 45.705L22.5669 38.1077C21.9341 37.1207 22.3628 35.8015 23.4549 35.3749L31.862 32.0924C32.1588 31.9765 32.421 31.786 32.6231 31.5394L38.3429 24.5583C39.086 23.6512 40.473 23.6512 41.2162 24.5583Z",
    fill: "#BA0000"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3499 23.9226L47.0698 30.9037C47.272 31.1501 47.5339 31.3407 47.831 31.4567L56.2378 34.7392C57.3301 35.1658 57.7587 36.485 57.1258 37.472L52.2539 45.0692C52.0818 45.3375 51.9818 45.6456 51.9632 45.9639L51.439 54.9738C51.3709 56.1444 50.2488 56.9597 49.1146 56.6626L40.3837 54.3768C40.075 54.2962 39.7512 54.2962 39.4427 54.3768L30.7118 56.6626C29.5776 56.9597 28.4554 56.1444 28.3874 54.9738L27.8632 45.9639C27.8446 45.6456 27.7446 45.3375 27.5725 45.0692L22.7008 37.472C22.0678 36.485 22.4966 35.1658 23.5886 34.7392L31.9955 31.4567C32.2926 31.3405 32.5546 31.1501 32.7566 30.9037L38.4768 23.9226C39.2197 23.0155 40.6069 23.0155 41.3499 23.9226Z",
    fill: "url(#paint6_linear_1577_4307)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.9353 45.7214C51.7635 45.9898 51.6631 46.2979 51.6447 46.6162L51.1204 55.6261C51.1127 55.7582 51.0486 55.8651 51.0156 55.9869C51.2412 55.7008 51.4153 55.3713 51.4385 54.9738L51.9627 45.9638C51.9747 45.7585 52.0731 45.5754 52.1503 45.3862L51.9353 45.7214Z",
    fill: "#FFD069"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2377 34.7392L47.8305 31.4566C47.5337 31.3405 47.2714 31.1501 47.0693 30.9033L41.3495 23.9222C40.6065 23.0155 39.2193 23.0155 38.4761 23.9222L32.7564 30.9033C32.5541 31.1501 32.2921 31.3405 31.9951 31.4566L23.5882 34.7392C22.997 34.9701 22.6236 35.4669 22.4844 36.0265C22.6836 35.7587 22.9313 35.5241 23.2703 35.3915L31.6773 32.1086C31.9745 31.9928 32.2364 31.8022 32.4386 31.5558L38.1583 24.5747C38.9015 23.6677 40.2889 23.6677 41.0317 24.5747L46.7516 31.5558C46.9535 31.8022 47.2157 31.9928 47.5127 32.1086L55.9199 35.3915C56.8873 35.7693 57.2871 36.8393 56.9362 37.7669L57.1255 37.4717C57.7585 36.4849 57.3297 35.1657 56.2377 34.7392Z",
    fill: "#FFD069"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.4821 55.5586L40.7512 53.2726C40.4429 53.192 40.1189 53.192 39.8104 53.2726L31.0795 55.5586C29.9453 55.8554 28.8232 55.0398 28.755 53.8694L28.231 44.8595C28.2125 44.5413 28.1125 44.2331 27.9403 43.9648L23.0685 36.3677C22.8661 36.0522 22.8069 35.7064 22.8086 35.363C22.3595 35.9586 22.2614 36.7874 22.7002 37.4717L27.5722 45.069C27.7443 45.3373 27.8443 45.6454 27.8629 45.9637L28.387 54.9736C28.455 56.144 29.5773 56.9595 30.7115 56.6624L39.4424 54.3766C39.7507 54.296 40.0749 54.296 40.383 54.3766L49.1139 56.6624C50.2482 56.9595 51.3704 56.144 51.4387 54.9736L51.4482 54.8102C51.0195 55.4168 50.2653 55.7635 49.4821 55.5586Z",
    fill: "url(#paint7_linear_1577_4307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6215 43.9648C52.4497 44.2331 52.3494 44.5413 52.3308 44.8595L52.3252 44.9573L57.1254 37.4715C57.3158 37.1747 57.3822 36.8507 57.391 36.527L52.6215 43.9648Z",
    fill: "url(#paint8_linear_1577_4307)"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M40.729 26.9434L45.5312 32.8046C45.7008 33.0115 45.9208 33.1715 46.1702 33.2688L53.2283 36.0248C54.1453 36.3829 54.5054 37.4904 53.9738 38.319L49.8835 44.6976C49.7389 44.9229 49.6549 45.1814 49.6394 45.4488L49.1995 53.0134C49.1424 53.9962 48.2002 54.6806 47.2477 54.4312L39.9178 52.512C39.6587 52.4443 39.3867 52.4443 39.1278 52.512L31.7978 54.431C30.8454 54.6805 29.903 53.996 29.8459 53.0133L29.4059 45.4486C29.3904 45.1814 29.3062 44.9227 29.1619 44.6974L25.0715 38.3189C24.5402 37.4902 24.9 36.3827 25.817 36.0246L32.8754 33.2686C33.1248 33.1712 33.3448 33.0114 33.5144 32.8045L38.3166 26.9432C38.9405 26.1819 40.105 26.1819 40.729 26.9434Z",
    fill: "#F53700"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1197 26.4989L45.922 32.3602C46.0916 32.567 46.3116 32.727 46.561 32.8245L53.6191 35.5805C54.5361 35.9386 54.8961 37.0461 54.3645 37.8747L50.2743 44.2533C50.1297 44.4786 50.0457 44.7371 50.0301 45.0045L49.5903 52.5688C49.5332 53.5517 48.5909 54.2362 47.6385 53.9867L40.3084 52.0677C40.0493 51.9998 39.7773 51.9998 39.5185 52.0677L32.1884 53.9867C31.2359 54.2362 30.2937 53.5517 30.2365 52.5688L29.7965 45.0045C29.781 44.7373 29.6969 44.4786 29.5525 44.2533L25.4621 37.8747C24.9308 37.0461 25.2906 35.9386 26.2076 35.5805L33.266 32.8245C33.5154 32.727 33.7354 32.5672 33.905 32.3602L38.7073 26.4989C39.3313 25.7376 40.4957 25.7376 41.1197 26.4989Z",
    fill: "url(#paint9_linear_1577_4307)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0226 44.8389C49.8783 45.0638 49.7943 45.3227 49.7786 45.5901L49.3386 53.1547C49.3338 53.2352 49.2907 53.2986 49.2744 53.375C49.4427 53.1435 49.5712 52.881 49.5896 52.569L50.0296 45.0046C50.0368 44.8774 50.1082 44.7677 50.1458 44.647L50.0226 44.8389Z",
    fill: "#FFE98B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6185 35.5805L46.5605 32.8245C46.311 32.727 46.091 32.5672 45.9214 32.36L41.1192 26.4989C40.4952 25.7374 39.3307 25.7374 38.7067 26.4989L33.9045 32.36C33.7345 32.5672 33.5147 32.727 33.2654 32.8245L26.207 35.5805C25.6837 35.7846 25.3707 36.2379 25.2725 36.7394C25.4416 36.497 25.6552 36.2835 25.956 36.1661L33.0144 33.4101C33.2638 33.3128 33.4838 33.1528 33.6534 32.9456L38.4557 27.0845C39.0793 26.3232 40.2443 26.3232 40.8681 27.0845L45.6704 32.9456C45.84 33.1528 46.0601 33.3126 46.3094 33.4101L53.3678 36.1661C54.1305 36.464 54.4729 37.275 54.2721 38.0182L54.3643 37.8747C54.8957 37.0461 54.5358 35.9386 53.6185 35.5805Z",
    fill: "#FFE98B"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M75.4931 38.1083L59.3847 10.2077C58.7089 9.03728 57.4601 8.31616 56.1083 8.31616H23.8915C22.5399 8.31616 21.2908 9.03728 20.615 10.2077L19.6475 11.8838L57.7731 71.2712C58.4324 70.9454 59.0044 70.4507 59.3846 69.7922L75.4931 41.8914C76.1687 40.7211 76.1687 39.2789 75.4931 38.1083Z",
    fill: "#FFDD45"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1577_4307",
    x1: 70.0771,
    y1: 50.6119,
    x2: -19.8212,
    y2: 18.8933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC64F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2772,
    stopColor: "#E06919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7073,
    stopColor: "#FFC640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA02B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1577_4307",
    x1: 16.5869,
    y1: 59.3992,
    x2: 77.3256,
    y2: 9.07263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC64F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2772,
    stopColor: "#E06919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7073,
    stopColor: "#FFC640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA02B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1577_4307",
    x1: 55.3019,
    y1: 22.7535,
    x2: -6.97254,
    y2: 92.9442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E06919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA02B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1577_4307",
    x1: 56.2277,
    y1: 21.6672,
    x2: 17.2244,
    y2: 65.6288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#941010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA02B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1577_4307",
    x1: 20.2116,
    y1: 65.9561,
    x2: 60.8985,
    y2: 12.5875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC64F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2772,
    stopColor: "#E06919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7073,
    stopColor: "#FFC640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA02B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1577_4307",
    x1: 31.4776,
    y1: 51.1784,
    x2: 59.3152,
    y2: 14.6642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC64F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2772,
    stopColor: "#E06919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7073,
    stopColor: "#FFC640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA02B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1577_4307",
    x1: 52.728,
    y1: 29.325,
    x2: 29.8061,
    y2: 53.0284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC64F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2772,
    stopColor: "#E06919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7073,
    stopColor: "#FFC640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA02B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1577_4307",
    x1: 39.8269,
    y1: 42.6963,
    x2: 28.7848,
    y2: 54.1147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC64F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2772,
    stopColor: "#E06919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7073,
    stopColor: "#FFC640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA02B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1577_4307",
    x1: 58.4406,
    y1: 37.0378,
    x2: 52.0822,
    y2: 43.6128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC64F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2772,
    stopColor: "#E06919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7073,
    stopColor: "#FFC640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA02B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1577_4307",
    x1: 29.0425,
    y1: 55.7237,
    x2: 50.0285,
    y2: 28.1966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC64F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2772,
    stopColor: "#E06919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7073,
    stopColor: "#FFC640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA02B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold);
export default __webpack_public_path__ + "static/media/gold.d9d87b02f1085d2e37eef485d7e7ff0b.svg";
export { ForwardRef as ReactComponent };